import { BoxManagementApi } from "./api.box";
import { CloudManagementApi } from "./api.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseManagementApi } from "./api.base";
import environment from "@/config";

export default getService<BaseManagementApi>(environment.nexus, {
    box: new BoxManagementApi(),
    cloud: new CloudManagementApi(),
});